import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { labelStyle } from '../InputLabel/wrapper';

export const Wrapper = styled.fieldset.withConfig({ componentId: 'sc-wol8nc-0' })`
    padding: 0;
    margin: 0;
    border: none;
    display: flex;
    flex-direction: column;
    gap: ${size(1)};
`;

export const Label = styled.legend.withConfig({ componentId: 'sc-wol8nc-1' })`
    ${labelStyle};
    padding: 0;
    margin-bottom: ${size(0.5)};
`;
